export default "__VITE_ASSET__ae9535be__"